export const radioTagItemStyle = (checked: boolean) => ({
  w: "50px",
  h: "26px",
  p: "4px 8px",
  fontSize: "12px",
  lineHeight: "18px",
  rounded: "4px",
  border: "1.5px solid",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  cursor: "pointer",
  fontWeight: 500,
  color: checked ? "brand.primary" : "text.placeholder",
  borderColor: checked ? "brand.primary" : "text.placeholder",
  _hover: {
    color: checked ? "brand.primary" : "#cccccc",
    borderColor: checked ? "brand.primary" : "#cccccc",
  },
});
